import React, { FC, useState, useEffect } from "react";

import { Carousel as ReactResponsiveCarousel } from "react-responsive-carousel";
import OveriewCarouselArrow from "./OverviewCarouselArrow";
import OverviewCarouselIndicators from "./OverviewCarouselIndicators";
import { OverviewCarouselModel } from "../../models/OverviewCarousel.model";
import { TOverviewCarouselProps } from "../../types/OverviewCarousel.type";
import ModalDialog from "../../../../react-only-components/ModalDialog/ModalDialog";
import ExpandableOverlay from '../ExpandableOverlay';
import "./styles.scss";

const OverviewCarousel: FC<TOverviewCarouselProps> = (props) => {
  const model = new OverviewCarouselModel(props);
  const [currentSlide, _setCurrentSlide] = useState(0);
  const [showOverlay, setShowOverlay] = useState(false);
  const hasMultipleSlides = model.slides?.length > 1;

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  const setCurrentSlide = hasMultipleSlides
    ? (index: number) => {
        if (currentSlide != index) {
          _setCurrentSlide(index);
        }
      }
    : () => {};

  const goToPreviousSlide = () => setCurrentSlide(currentSlide - 1);
  const goToNextSlide = () => setCurrentSlide(currentSlide + 1);
  const openOverlayModal = () => setShowOverlay(true);
  const closeOverlayModal = () => setShowOverlay(false);

  return (
    <div className="series-overview-carousel">
      <div className="series-overview-carousel__wrapper">
        <ReactResponsiveCarousel
          infiniteLoop={true}
          autoPlay={false}
          onChange={setCurrentSlide}
          selectedItem={currentSlide}
          showThumbs={false}
          showArrows={false}
          showIndicators={false}
          showStatus={false}
        >
          {model.slides?.map((slide, index) => {
            return (
              <div key={`overview-carousel-slide-${index}`}>
                <img
                  src={slide.bigthumbnail}
                  alt={slide.alt}
                  loading="lazy"
                  className="series-overview-carousel__desktop-image"
                />
                <img
                  src={slide.thumbnail}
                  alt={slide.alt}
                  loading="lazy"
                  className="series-overview-carousel__mobile-image"
                />
              </div>
            );
          })}
        </ReactResponsiveCarousel>
        <div className="series-overview-carousel__expand-icon" onClick={openOverlayModal}>
          <pfe-icon icon="dcx-expand" color="complement" size="24"></pfe-icon>
        </div>
        {hasMultipleSlides && (
          <>
            <OveriewCarouselArrow
              direction={"previous"}
              onClick={goToPreviousSlide}
            />
            <OverviewCarouselIndicators
              numOfSlides={model.slides?.length}
              currentSlideIndex={currentSlide}
            />
            <OveriewCarouselArrow direction={"next"} onClick={goToNextSlide} />
          </>
        )}
        {(model.slides?.length || model.video) && (
          <ModalDialog
            isOpen={showOverlay}
            close={closeOverlayModal}
            className="series-overview-modal"
          >
            <ExpandableOverlay {...props}/>
          </ModalDialog>
        )}
      </div>
    </div>
  );
};

export default OverviewCarousel;
